import React from "react";
import { useQueryClient } from "@tanstack/react-query";

export const withQueryClient = (Component) => (props) => {
  var queryClient = useQueryClient();
  return <Component {...props} queryClient={queryClient} />;
};
